export default {"src":"/_next/static/media/Footer logo-12.ee9699f8.svg","height":425,"width":1191,"blurWidth":0,"blurHeight":0};